export default "__VITE_ASSET__BG0UuIH4__"